var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page"}},[_c('DefaultHeader'),_c('Rview')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }